// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tb-2";
export var container = "_tb-4";
export var dismissButton = "_tb-3";
export var hasPaddingBottom = "_tb-6";
export var last = "_tb-e";
export var scrollbarThumb = "_tb-c";
export var scrollbarTrack = "_tb-b";
export var selected = "_tb-9";
export var spin = "_tb-1";
export var spinning = "_tb-0";
export var suggestionItem = "_tb-d";
export var suggestionsPanel = "_tb-5";
export var tonePill = "_tb-8";
export var tonesContainer = "_tb-7";
export var unselected = "_tb-a";